import store from "@/store";
import {api} from "@/utils/api";
import {getUserAgent} from "@/utils/utils";

export default {
  install(Vue, options) {
    Vue.prototype.$addAccessLog = (bizPkId, bizType, accessUrl, accessInfo) => {
      return new Promise((resolve, reject) => {
        let data = {
          accountId: store.getters.userInfo.accountId || '',
          bizPkId: bizPkId,
          bizType: bizType,
          accessUrl: accessUrl || 'developer',
          accessInfo: accessInfo,
          accessSide: getUserAgent()
        };
        api({
          method: "qfwMenuAccessLog/add",
          obj: data
        }).then(() => {
          resolve();
        }).catch(() => {
          resolve();
        });
      });
    };
  }
}



// WEBPACK FOOTER //
// ./src/plugins/addAccessLog.js